import { render } from "./swipe_click.vue?vue&type=template&id=4c0f684c"
import script from "./swipe_click.js?vue&type=script&lang=js"
export * from "./swipe_click.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__